import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { mobile, tablet } from '../responsive';
import { Link } from "react-router-dom";
import {theme_colors} from '../data';


const Container = styled.div`
    width: 100%;
   // height: 100vh;
    background-color: ${theme_colors.bg_main};
    display: flex;
    justify-content: center;
    /* padding-top: 70px;
    padding-bottom: 70px; */
    ${mobile({
        flexDirection: "column",
        height: "max-content",
        justifyContent: "center",
        paddingLeft: "15px",
        paddingRight: "15px"
    })}
`;
const Wrapper = styled.div`
    width: 90%;
    margin-top: 130px;
    margin-bottom: 50px;
    ${mobile({
        width: "100%",
    })}
`;
const Head = styled.div`
    width: 100%;
`;
const Title = styled.div`
    color: ${theme_colors.secondary_color};
    font-size: 45px;
    font-weight: 700;
    text-transform: capitalize;
    line-height: 48px;
    margin-bottom: 10px;
    ${tablet({
        fontSize: "42px",
        lineHeight: "45px"
    })}
    ${mobile({
        fontSize: "27px",
        lineHeight: "38px",
    })}
`;
const Desc = styled.div`
    width: 70%;
    color: ${theme_colors.secondary_color};
    font-size: 16px;
    font-weight: 300;
    line-height: 22px;
    ${tablet({
        fontSize: "20px",
        lineHeight: "25px"
    })}
    ${mobile({
        width: "100%",
        fontSize: "18px",
        lineHeight: "23px",
        fontWeight: "400",
        marginBottom: "60px"
    })}
`;
const Content = styled.div`
    width: 100%;
    margin-top: 50px;
`;
const Block = styled.div`
    width: 100%;
    margin-bottom: 50px;
`;
const BlockHead = styled.div`
    color: ${theme_colors.secondary_color};
    margin-bottom: 10px;
    font-size: 20px;
    font-weight: 600;
    line-height: 26px;
    text-transform: capitalize;
    ${tablet({

    })}
    ${mobile({
        fontSize: "20px",
    })}
`;
const Body = styled.div`
    width: 70%;
    color: ${theme_colors.secondary_color};
    font-size: 16px;
    font-weight: 300;
    line-height: 22px;
    margin-bottom: 30px;
    ${tablet({
        fontSize: "20px",
        lineHeight: "25px"
    })}
    ${mobile({
        width: "100%",
        fontSize: "18px",
        lineHeight: "23px",
        fontWeight: "400",
        marginBottom: "60px"
    })}
`;
const TableContainer = styled.div`
    width: 70%;
    border-top: 1px solid #000;
    border-bottom: 1px solid #000;
    padding-top: 40px;
    padding-bottom: 40px;
    margin-top: 30px;
    ${mobile({
        width: "100%",
        borderBottom: "none",
        paddingBottom: "0px"
    })}
`;
const TableHead = styled.div`
    width: 100%;
    display: flex;
    margin-bottom: 40px;
    ${mobile({
        display: "none"
    })}
`;
const TypeCol = styled.div`
    width: 35%;
    display: flex;
    ${mobile({
        width: "100%",
        marginBottom: "10px"
    })}
`;
const PurposeCol = styled.div`
    width: 64%;
    display: flex;
    ${mobile({
        width: "100%",
    })}
`;
const TypeHeadText = styled.div`
    color: ${theme_colors.secondary_color};
    font-size: 16px;
    font-weight: 600;
    line-height: 22px;
    text-transform: capitalize;
    ${tablet({

    })}
    ${mobile({
        width: "100%",
        fontSize: "18px",
        lineHeight: "23px",
        fontWeight: "400",
        marginBottom: "60px"
    })}
`;
const PurposeHeadText = styled.div`
    color: ${theme_colors.secondary_color};
    font-size: 16px;
    font-weight: 600;
    line-height: 22px;
    text-transform: capitalize;
    ${tablet({

    })}
    ${mobile({
        width: "100%",
        fontSize: "18px",
        lineHeight: "23px",
        fontWeight: "400",
        marginBottom: "60px"
    })}
`;
const TableItems = styled.div`
    width: 100%;
`;
const TableItem = styled.div`
    width: 100%;
    display: flex;
    margin-bottom: 20px;
    ${mobile({
        flexDirection: "column",
        marginBottom: "40px",
        paddingBottom: "40px",
        borderBottom: "1px solid #000000"
    })}
`;
const TypeText = styled.div`
    color: ${theme_colors.secondary_color};
    font-size: 16px;
    font-weight: 300;
    line-height: 22px;
    text-transform: capitalize;
    ${tablet({

    })}
    ${mobile({
        fontSize: "18px",
        lineHeight: "23px",
        fontWeight: "600",
    })}
`;
const PurposeText = styled.div`
    color: ${theme_colors.secondary_color};
    font-size: 16px;
    font-weight: 300;
    line-height: 22px;
    ${tablet({

    })}
    ${mobile({
        fontSize: "18px",
        lineHeight: "23px",
    })}
`;


export default function Cookies() {

    useEffect(() => {
        document.title = "Cookie Policy | Kudi Group - Management Consulting and Financial Planners";
        window.scrollTo(0, 0)
    }, []);

  return (
    <Container>
        <Wrapper>
                <Head>
                    <Title>Cookie policy</Title>
                    <Desc>
                        <p>Effective date: February 6, 2023</p>
                        <p>Kudi Group and its subsidiaries and affiliates (collectively, “Kudi Group”, “us” or “we”) understand that your privacy is important to you and are committed to being transparent about the technologies it uses. This Cookie Policy explains how and why cookies, web beacons, pixels, clear gifs, and other similar technologies (collectively “Cookies and Other Tracking Technologies”) may be stored on and accessed from your device when you use or visit any website or app that posts a link to this Policy (collectively, “the Sites”). This Cookie Policy should be read together with our <Link to={`/terms`} style={{ textDecoration: 'none' }}>Privacy Policy</Link> and our <Link to={`/terms`} style={{ textDecoration: 'none' }}>Terms of use</Link>.</p>
                    </Desc>
                </Head>
            <Content>
                    <Block>
                    <BlockHead>What are Cookies and Other Tracking Technologies?</BlockHead>
                        <Body>
                           <p>A cookie is a small text file that can be stored on and accessed from your device when you visit one of our Sites, to the extent you agree. The other tracking technologies work similarly to cookies and place small data files on your devices or monitor your website activity to enable us to collect information about how you use our Sites. This allows our Sites to recognize your device from those of other users of the Sites. The information provided below about cookies also applies to these other tracking technologies. You can find more information at <a href='http://www.allaboutcookies.org/'>www.allaboutcookies.org</a> and <a href='http://www.youronlinechoices.eu/'>www.youronlinechoices.eu</a>.</p>
                        </Body>
                    </Block>
                    <Block>
                        <BlockHead>How do our Sites use Cookies and Other Tracking Technologies?</BlockHead>
                        <Body>
                            <p>Kudi Group uses Cookies and Other Tracking Technologies to identify you and your interests, to remember your preferences, and to track your use of our Sites. We also use Cookies and Other Tracking Technologies to control access to certain content on our Sites, protect the Sites, and to process any requests that you make of us.</p>
                            <p>To administer our Sites and for research purposes, Kudi Group also has contracted with third party service providers to track and analyze statistical usage and volume information from our Site users. These third party service providers use persistent Cookies to help us to improve the user experience, manage our Site content, and analyze how users navigate and utilize the Sites.</p>
                        </Body>
                    </Block>
                    <Block>
                        <BlockHead>First and Third Party Cookies</BlockHead>
                        <Body>
                            <p>“First party Cookies” are cookies that belong to Kudi Group and that Kudi Group places on your device. “Third party Cookies” are cookies that another party places on your device through our Site. Kudi Group may contract with third party service providers to send e-mails to users who have provided us with their contact information. To help measure and improve the effectiveness of our e-mail communications, and/or to determine whether messages have been opened and links clicked on, the third party service providers may place Cookies on the devices of these users.</p>
                            <p>For more information on how these companies collect and use information on our behalf, please refer to their privacy policies as indicated below.</p>
                            <p>Depending on the Site, we use the following types of cookies:</p>
                            <p>Persistent Cookies. We use persistent Cookies to improve your experience of using the Sites. This includes recording your acceptance of our Cookie Policy to remove the cookie message which first appears when you use the Sites.</p>
                            <p>Session Cookies. Session Cookies are temporary and deleted from your machine when your web browser closes. We use session Cookies to help us track internet usage as described above.</p>
                            <p>You may refuse to accept browser Cookies by activating the appropriate setting on your browser. However, if you select this setting you may be unable to access certain parts of the Sites. Unless you have adjusted your browser setting so that it will refuse Cookies, our system will issue Cookies when you direct your browser to our Sites.</p>
                            <p>The data collected by the Sites and/or through Cookies that may be placed on your computer will not be kept for longer than is necessary to fulfill the purposes mentioned above. In any event, such information will not be kept for longer than one year.</p>
                        </Body>
                    </Block>
                    <Block>
                        <p>Our Cookies are used for the following purposes:</p>
                        <TableContainer>
                            <TableHead>
                                <TypeCol>
                                    <TypeHeadText>Cookie type</TypeHeadText>
                                </TypeCol>
                                <PurposeCol>
                                    <PurposeHeadText>Purpose</PurposeHeadText>
                                </PurposeCol>
                            </TableHead>
                            <TableItems>
                                <TableItem>
                                    <TypeCol>
                                        <TypeText>Strictly Necessary/ Technical</TypeText>
                                    </TypeCol>
                                    <PurposeCol>
                                        <PurposeText>These Cookies are necessary to allow us to operate our Sites so you may access them as you have requested. These Cookies, for example, let us recognize that you have created an account and have logged into that account to access Site content. They also include Cookies that enable us to remember your previous actions within the same browsing session and secure our Sites.</PurposeText>
                                    </PurposeCol>
                                </TableItem>
                                <TableItem>
                                    <TypeCol>
                                        <TypeText>Analytical/ Performance</TypeText>
                                    </TypeCol>
                                    <PurposeCol>
                                        <PurposeText>These Cookies are used by us or third party service providers to analyze how the Sites are used and how they are performing. For example, these Cookies track what pages are most frequently visited, and from what locations our visitors come from. If you subscribe to a newsletter or otherwise register with the Sites, these Cookies may be correlated to you. These Cookies include, for example, Adobe Analytics cookies.</PurposeText>
                                    </PurposeCol>
                                </TableItem>
                                <TableItem>
                                    <TypeCol>
                                        <TypeText>Functionality</TypeText>
                                    </TypeCol>
                                    <PurposeCol>
                                        <PurposeText>These Cookies let us operate the Sites in accordance with the choices you make. These Cookies permit us to "remember" you in-between visits. For instance, we will recognize your user name and remember how you customized the Sites and services, for example by adjusting text size, fonts, languages and other parts of web pages that are alterable, and provide you with the same customizations during future visits.</PurposeText>
                                    </PurposeCol>
                                </TableItem>
                                <TableItem>
                                    <TypeCol>
                                        <TypeText>Third party advertising</TypeText>
                                    </TypeCol>
                                    <PurposeCol>
                                        <PurposeText>These Cookies collect information about your activities on these and other sites to provide you targeted advertising. We may also allow our third party service providers to use Cookies on the Sites for the same purposes identified above, including collecting information about your online activities over time and across different websites. The third party service providers that generate these Cookies, such as <a href='https://www.adobe.com/privacy/policy.html'>Adobe</a>, <a href='https://www.linkedin.com/legal/privacy-policy'>LinkedIn</a>, <a href='https://twitter.com/en/privacy'>Twitter</a> and <a href='https://www.facebook.com/policy.php'>Facebook</a>, have their own privacy policies, and may use their Cookies to target advertising to you on other websites, based on your visit to our Sites.</PurposeText>
                                    </PurposeCol>
                                </TableItem>
                            </TableItems>
                        </TableContainer>
                    </Block>
                    <Block>
                        <BlockHead>How do I refuse or withdraw my consent to the use of Cookies?</BlockHead>
                        <Body>
                            <p>If you do not want Cookies to be dropped on your device, you can adjust the setting of your Internet browser to reject the setting of all or some Cookies and to alert you when a Cookie is placed on your device. For further information about how to do so, please refer to your browser ‘help’ / ‘tool’ or ‘edit’ section or see <a href='http://www.allaboutcookies.org/'>www.allaboutcookies.org</a> . Please note that if you use your browser settings to block all Cookies (including strictly necessary Cookies) you may not be able to access or use all or parts or functionalities of our Sites.</p>
                            <p>If you want to remove previously-stored Cookies, you can manually delete the Cookies at any time. However, this will not prevent the Sites from placing further Cookies on your device unless and until you adjust your Internet browser setting as described above.</p>
                            <p>For more information on the development of user-profiles and the use of targeting/advertising Cookies, please see <a href='http://www.youronlinechoices.eu/'>www.youronlinechoices.eu</a> if you are located in Europe or <a href='http://www.aboutads.info/choices'>www.aboutads.info/choices</a> if in the United States.</p>
                        </Body>
                    </Block>
                    <Block>
                        <BlockHead>How do we use Other Tracking Technologies in our communications?</BlockHead>
                        <Body>
                            <p>Kudi Group may collect information about whether you open or click any links in the knowledge, research or event communications that we send to you through web beacons.</p>
                            <p>A web beacon is a graphic image, which is placed on a website or in an email that alone or in conjunction with cookies compile information about your usage of or your interaction with a Kudi Group website or email. For example, we may add web beacons to the knowledge, research or event communications that we send to you to determine whether you have opened our email or clicked a link. The analysis gathered helps us improve the effectiveness of content and format of our websites and email communications.</p>
                        </Body>
                    </Block>
                    <Block>
                        <BlockHead>How do I refuse or withdraw my consent to the use of Web Beacons?</BlockHead>
                        <Body>
                            You may avoid web beacons by configuring your email reader program to disable the functionality that enables remote images to load and by refraining from clicking on any links in email messages.
                        </Body>
                    </Block>
                    <Block>
                        <BlockHead>Contact us</BlockHead>
                        <Body>
                            <p>If you have any other questions about our Cookie Policy, please contact us at:</p>
                            <p>Kudi Group<br/>
                                <a href="tel:+1 614 733 9671">614 733 9671</a><br />
                                <a href='mailto:info@kudigroup.com'>info@kudigroup.com</a>
                            </p>
                        </Body>
                    </Block>
            </Content>
        </Wrapper>
    </Container>
  )
}
